// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2763":"css/app.6687","7422":"css/admin-app.6687"}[chunkId] + ".css";
};